import * as LucideIcons from "lucide-react";
import * as FontAwesomeIcons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as BsIcons from "react-icons/bs";
import { cn } from "../../Lib/Cn";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { getThreadTypesArr, getTransactionTypesArr } from "../../Store/Reducers";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../Components/UI/tooltip";

export default function ThreadSahiIcon({
  tID,
  className = "",
  size = 18,
  hoverName = false, // default false
  Xns = false
}) {
  const XnTypes = useSelector(getTransactionTypesArr);
  const threadTypes = useSelector(getThreadTypesArr);

  const renderIcon = useMemo(() => {
    if (Xns) {
      const XnType = XnTypes.find((t) => t.XnTID === tID);

      const iconName = XnType?.Icon || "Banknote";
      const flow = XnType?.Typ || "S";

      const colorClass = flow === "S" ? "text-sahi-green" : "text-sahi-orange";
      const commonProps = {
        className: cn(`w-[${size}px] h-[${size}px]`, colorClass, className),
      };

      let iconElement;

      // Lucide icons (default)
      if (LucideIcons[iconName]) {
        const LucideIcon = LucideIcons[iconName];
        iconElement = <LucideIcon {...commonProps} />;
      }
      // FontAwesome icons
      else if (FontAwesomeIcons[iconName]) {
        iconElement = (
          <FontAwesomeIcon
            icon={FontAwesomeIcons[iconName]}
            className={cn("w-[20px] h-[20px]", colorClass, className)}
          />
        );
      }
      // Bootstrap icons (react-icons/bs)
      else if (BsIcons[iconName]) {
        const BsIcon = BsIcons[iconName];
        iconElement = <BsIcon {...commonProps} />;
      }
      // Fallback
      else {
        const FallbackIcon = LucideIcons.CircleHelp;
        iconElement = <FallbackIcon {...commonProps} />;
      }

      if (hoverName && XnType?.LblF) {
        return (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="inline-flex items-center">{iconElement}</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>{XnType.LblF}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      }

      return iconElement;
    } else {
      const threadType = threadTypes.find((t) => t.TID === tID);

      const iconName = threadType?.Icon || "CircleHelp";
      const flow = threadType?.Flow || "In";

      const colorClass = flow === "In" ? "text-sahi-green" : "text-sahi-orange";
      const commonProps = {
        className: cn(`w-[${size}px] h-[${size}px]`, colorClass, className),
      };

      let iconElement;

      // Lucide icons (default)
      if (LucideIcons[iconName]) {
        const LucideIcon = LucideIcons[iconName];
        iconElement = <LucideIcon {...commonProps} />;
      }
      // FontAwesome icons
      else if (FontAwesomeIcons[iconName]) {
        iconElement = (
          <FontAwesomeIcon
            icon={FontAwesomeIcons[iconName]}
            className={cn("w-[20px] h-[20px]", colorClass, className)}
          />
        );
      }
      // Bootstrap icons (react-icons/bs)
      else if (BsIcons[iconName]) {
        const BsIcon = BsIcons[iconName];
        iconElement = <BsIcon {...commonProps} />;
      }
      // Fallback
      else {
        const FallbackIcon = LucideIcons.CircleHelp;
        iconElement = <FallbackIcon {...commonProps} />;
      }

      if (hoverName && threadType?.Sgn) {
        return (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="inline-flex items-center">{iconElement}</span>
              </TooltipTrigger>
              <TooltipContent>
                <p>{threadType.TypSng}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      }

      return iconElement;
    }
  }, [Xns, XnTypes, threadTypes, tID, size, className, hoverName]);

  return renderIcon;
}